module.exports = __webpack_public_path__ + "img/lang_kubernetes.df74c3b3.png";